import {
    Box, Text, Flex, Heading, Button, VStack, Input, Textarea, FormControl, useToast
} from "@chakra-ui/react"
import emailjs from "@emailjs/browser"
import { useEffect, useState } from "react"
import { motion, Variants } from "framer-motion"


export const ContactPage = () => {

    const container: Variants = {
        hidden: {
            y: 300,
            opacity: 0
        },
        show: {
            opacity: 1,
            y: 0,
            transition: {
                type: "spring",
                bounce: 0.4,
                duration: 0.8,
                delayChildren: 0.3,
                staggerChildren: 0.2
            }
        }
    };

    const items: Variants = {
        hidden: {
            y: 25,
            opacity: 0
        },
        show: {
            opacity: 1,
            y: 0,
        }
    }


    useEffect(() => {
        emailjs.init({
            publicKey: 'l_sQVCIYIF0t8J4xH',
            // Do not allow headless browsers
            blockHeadless: true,
            blockList: {
                // Block the suspended emails
                list: [],
                // The variable contains the email address
                watchVariable: 'userEmail',
            },
            limitRate: {
                // Set the limit rate for the application
                id: 'app',
                // Allow 1 request per 10s
                throttle: 10000,
            },
        });
    }, [])

    const toast = useToast()

    const [emailValue, setEmailValue] = useState("")
    const [nameValue, setNameValue] = useState("")
    const [messageValue, setMessageValue] = useState("")

    const [validEmail, setValidEmail] = useState(true)
    const [validName, setValidName] = useState(true)
    const [validMessage, setValidMessage] = useState(true)
    const [isDisabled, setIsDisabled] = useState(false)
    const [cooldown, setCooldown] = useState(false)

    function handleEmailChange(e: React.ChangeEvent<HTMLInputElement>) {
        setEmailValue(e.target.value)
        setValidEmail(true)
    }
    function handleNameChange(e: React.ChangeEvent<HTMLInputElement>) {
        setNameValue(e.target.value)
        setValidName(true)
    }
    function handleMessageChange(e: React.ChangeEvent<HTMLTextAreaElement>) {
        setMessageValue(e.target.value)
        setValidMessage(true)
    }

    function handleSubmit(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault()
        if (!emailValue.toLowerCase().match(/^\S+@\S+\.\S+$/)) {
            setValidEmail(false)
            toast({
                title: 'Message not submited.',
                description: 'Please enter a valid email address.',
                status: "error",
                duration: 9000,
                isClosable: true
            })
            return
        } else if (nameValue === "") {
            setValidName(false)
            toast({
                title: 'Message not submited.',
                description: 'Please enter a name.',
                status: "error",
                duration: 9000,
                isClosable: true
            })
            return
        } else if (messageValue === "") {
            setValidMessage(false)
            toast({
                title: 'Message not submited.',
                description: 'Please enter a message.',
                status: "error",
                duration: 9000,
                isClosable: true
            })
            return
        } else {
            setValidEmail(true)
            setValidName(true)
            setValidMessage(true)
            if (!isDisabled) {
                // emailjs.send("service_5qxa8i9","template_f0klivy",{
                //     to_name: "Ahmed Imana",
                //     from_name: nameValue,
                //     message: messageValue,
                //     reply_to: emailValue,
                //     });
                fetch("https://formsubmit.co/ajax/ahmedimana.work@gmail.com", {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        name: nameValue,
                        message: messageValue
                    })
                })
                .then(response => response.json())
                .then(data => console.log(data))
                .catch(error => console.log(error))

                toast({
                    title: 'Message submitted!',
                    description: 'Your message has been submitted, thank you ' + nameValue + "!",
                    status: "success",
                    duration: 9000,
                    isClosable: true
                })
                setIsDisabled(true)

            } else if (isDisabled) {
                toast({
                    title: 'Message not submitted!',
                    description: 'Woah, slow down there! Please wait 15 seconds before sending another message.',
                    status: "warning",
                    duration: 9000,
                    isClosable: true
                })
                if (!cooldown) {
                    setTimeout(() => {
                        setIsDisabled(false)
                        setCooldown(false)
                    }, 15000)

                }
                setCooldown(true)
            }

        }
    }


    return (
        <motion.div variants={container} whileInView="show" initial="hidden" viewport={{ once: true }}>

        <Flex pt="7rem" id="CONTACT" className="hidden" width="100%" bg="background" direction="column" justifyContent="center">
            <Flex
                bg="container_bg"
                px="2rem" pt="2rem" pb="1.5rem" borderRadius="20px" margin="1rem auto" width="90%" height="100%"
                border="solid 0.5px var(--chakra-colors-container_outline)"
                boxShadow="0px 0px 8px 0px var(--chakra-colors-container_shadow)"
                direction="column" textAlign="left" alignItems="left">
                <Box as={motion.div} variants={items} mb="1.5rem" textAlign="left">
                    <Heading variant="special" as="span">LET'S TALK</Heading>
                    <Heading variant="special" as="span" color="accent" >.</Heading>
                </Box>
                <Text as={motion.div} variants={items} pb="1rem" variant="body" fontWeight="regular" fontSize='20'>Got something you need help designing or deploying? Feel free to reach out below.</Text>

                <FormControl >
                    <VStack as={motion.div} variants={items} color="#636363" spacing="5px" maxWidth="100vw">
                        <Flex width="100%" maxWidth="100%" >
                            <Input onChange={handleEmailChange} isInvalid={!validEmail} mr="2.5px" rounded="10" bg="container_bg_alt" type="email" pattern=".+@example\.com" placeholder='Email' required/>
                            <Input onChange={handleNameChange} isInvalid={!validName} ml="2.5px" rounded="10" bg="container_bg_alt" placeholder='Name' required/>
                        </Flex>
                        <Textarea onChange={handleMessageChange} isInvalid={!validMessage} rounded="10" bg="container_bg_alt" minH="15rem" placeholder="Message" required/>
                        <Button width="100%" variant="moreinfo" onClick={handleSubmit}>SUBMIT INQUIRY</Button>
                        {/* <Text>{isDisabled ? "disabled" : "active"}</Text> */}
                    </VStack>
                </FormControl>
            </Flex>
        </Flex>
        </motion.div>
    )
}